EMBEDDED SIGN COMPONENT

<div class="message" *ngIf="done">
  Your signature has been completed.
  <br />You may close this window and return to Procore.
</div>